import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

interface Row { userId: string; nickname: string; count: number; position: number }

/** Popup classifica interventi: lista ordinata + medaglie 1°/2°/3° */
export function LeaderboardModal({ onClose }: { onClose: () => void }): React.JSX.Element {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const { data } = useQuery<Row[]>({
    queryKey: ['leaderboard', year],
    queryFn: async () => (await api.get('/interventions/leaderboard', { params: { year } })).data,
  });
  const rows = data ?? [];

  function medal(pos: number): string {
    if (pos === 1) return '🥇';
    if (pos === 2) return '🥈';
    if (pos === 3) return '🥉';
    return `${pos}°`;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}
        style={{ maxWidth: 480, maxHeight: '80vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ margin: 0 }}>🏆 Classifica Interventi</h3>
          <select value={year} onChange={e => setYear(parseInt(e.target.value, 10))}
            style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #ced4da' }}>
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>

        {rows.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#888', padding: 30 }}>
            Nessun intervento registrato per l'anno {year}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {rows.map(r => (
              <div key={r.userId} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 14px', borderRadius: 8,
                background: r.position === 1 ? '#fff3cd'
                  : r.position === 2 ? '#e2e3e5'
                  : r.position === 3 ? '#f8d7c6' : '#f8f9fa',
                border: r.position <= 3 ? `2px solid ${r.position === 1 ? '#ffc107' : r.position === 2 ? '#6c757d' : '#fd7e14'}` : '1px solid #dee2e6',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <span style={{ fontSize: r.position <= 3 ? 24 : 16, minWidth: 30 }}>{medal(r.position)}</span>
                  <span style={{ fontWeight: 600 }}>{r.nickname}</span>
                </div>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#dc3545' }}>{r.count}</span>
              </div>
            ))}
          </div>
        )}

        <button onClick={onClose} style={{ marginTop: 16, width: '100%', padding: 10, border: 'none',
          borderRadius: 8, cursor: 'pointer', background: '#6c757d', color: 'white', fontWeight: 600 }}>
          Chiudi
        </button>
      </div>
    </div>
  );
}
